import React, { useState } from 'react';
import {
    CalculatorOutlined
} from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Modal,
    Row,
    Col,
    Typography,
    InputNumber,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function AdjustStock({ data }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation({
        mutationFn: (values) => {
            axios
                .post(`/api/adjustStockLog/`, values)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => setOpen(false)
                    });
                    queryClient.invalidateQueries(['/api/product/'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });


    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ ...values, product: data._id }))
    };

    const onCancelCreate = () => {
        setOpen(false);
    }

    // console.log(data);
    return (
        <div>
            {contextHolder}
            <Button
                type='text'
                icon={<CalculatorOutlined />}
                style={{ color: '#FAAD14' }}
                onClick={() => setOpen(true)} />
            <Modal
                open={open}
                title={
                    <div>
                        <Typography.Title level={4} style={{ padding: '0px', margin: '0px' }}>แก้ไขสต๊อกสินค้า</Typography.Title>
                        <Typography.Paragraph >
                            {`${data.name} : ${data.brand.name} ${data.description}`}
                        </Typography.Paragraph>
                    </div>
                }
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`edit${data._id}`}
                    initialValues={{
                        stock: data.stock,
                        average_price: data.average_price,
                    }}
                >
                    <Row gutter={[8, 8]}>
                        <Col xs={12}>
                            <Form.Item
                                label="จำนวนคงเหลือ"
                                name="stock"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="มูลค่าต่อหน่วย"
                                name="average_price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item
                                name="description"
                                label="รายละเอียด"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <Input.TextArea rows={2} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>
    )
}
